module.exports = __webpack_public_path__ + "static/C3-e6cbd6b0f8596af0e06f11f4232ceb21.jpg";